import React from "react";

// reactstrap components
import {
    FormGroup,
    Button,
    Card,
    CardHeader,
    CardBody,
    Modal,
    CardFooter,
} from "reactstrap";
import CreditDataService from "../../services/CreditDataService";
import CreditReports from "components/Tables/CreditReport";

class CreditLunasiModal extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            defaultModal: false,
            reports: [],
            currentCheckout: {},
            currentCheckoutListItem: {},
            prompMessage: undefined,
        };
        this.creditDataService = new CreditDataService();
    }

    onModalOpened() {
        this.fetchData();
        this.setState({
            prompMessage: 'Anda yakin ingin melunasi kredit ini?',
            report: {
                report_id: 0
            },
        })
    }

    fetchData() {
        this.creditDataService
            .getReports(1, 99999, 1)
            .then(res => {
                this.setState(res)
            });
    }

    onModalClosed() {
        this.setState({
            currentProduct: {},
            errorMessages: [],
        })
    }

    handleProceed() { }

    handleExportById() { }

    selectReport(report) {
        this.setState({
            prompMessage: 'Anda yakin ingin lunas menggunakan report ' + report.report_name + '?',
            report: report,
        })
    }

    render() {
        return (
            <Modal
                className="modal-dialog-centered"
                size="lg"
                isOpen={this.props.formModal}
                toggle={this.props.toggleModal}
                onOpened={this.onModalOpened.bind(this)}
                onClosed={this.onModalClosed.bind(this)}
            >
                <div className="modal-body p-0">
                    <Card className="bg-secondary shadow border-0">
                        <CardHeader className="bg-transparent">
                            <div className="text-muted text-center mt-2 mb-3">
                                <h3 className="mb-0">Lunasi kredit</h3>
                            </div>
                        </CardHeader>
                        {/* <CardBody className="px-lg-5 py-lg-5">
                            <CreditReports
                                items={this.state.reports}
                                handleProceed={this.handleProceed.bind(this)}
                                handleExportById={this.handleExportById.bind(this)}
                                selectReport={this.selectReport.bind(this)}
                                isLunasi={true}
                            />
                        </CardBody> */}
                        {this.state.prompMessage && (
                            <CardBody>
                                <FormGroup>
                                    <h3>
                                        {this.state.prompMessage}
                                    </h3>
                                    <div className="btn-wrapper text-right">
                                        <Button
                                            className="my-4"
                                            color="secondary"
                                            type="button"
                                            onClick={this.props.toggleModal}
                                        >
                                            Batal
                                        </Button>
                                        <Button
                                            className="my-4"
                                            color="primary"
                                            type="button"
                                            onClick={() => this.props.handleLunasi(this.props.kreditId, this.state.report.report_id)}
                                        >
                                            Lunasi
                                        </Button>
                                    </div>
                                </FormGroup>
                            </CardBody>
                        )}
                    </Card>
                </div>
            </Modal>
        )
    }
}

export default CreditLunasiModal;
